import { CIVILREG_COUNTRIES, CIVILREG_SERVICES } from "./index";
import { buildLegalClusterQA, toAxis, type WaveQA } from "../_qa/legal-clusters";

export type CivilRegQA = WaveQA;

export const CIVILREG_REVIEWED_TH = "สิงหาคม 2569";
export const CIVILREG_REVIEWED_ISO = "2026-08-07";

export const CIVILREG_QA: CivilRegQA[] = buildLegalClusterQA({
  prefix: "civilreg",
  clusterTh: "งานทะเบียนราษฎรและทะเบียนครอบครัว",
  authorityTh: "สำนักทะเบียนอำเภอ/เขต หรือสถานทูตไทยที่มีเขตอำนาจ",
  reviewedTh: CIVILREG_REVIEWED_TH,
  volatileNote:
    "แนวปฏิบัติของแต่ละสำนักทะเบียนต่างกันได้ ควรยืนยันกับสำนักทะเบียนที่จะยื่นก่อนเดินทาง",
  topics: toAxis(CIVILREG_SERVICES),
  extraTopics: toAxis(CIVILREG_COUNTRIES, "ctry"),
});

export const CIVILREG_QA_BY_SLUG: Record<string, CivilRegQA> = Object.fromEntries(
  CIVILREG_QA.map((qa) => [qa.slug, qa]),
);

export const CIVILREG_QA_COUNT = CIVILREG_QA.length;
